module.exports = __webpack_public_path__ + "static/img/RGH-who-we-are-Header.4f6cf26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/whoweare/RGH-who-we-are-Header.jpg
// module id = YFjs
// module chunks = 1